import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import config from 'config';

import { pushWithQuery as push } from 'utils/routing';

import { compose } from 'recompose';

import { openFinishedWithFilter } from 'redux/modules/finished-journeys/effects';

import { preserveScroll } from 'utils/router';

import CarrierDetails from './CarrierDetails';
import CarrierEdit from './CarrierEdit';
import CarrierDriverEdit from './CarrierDriverEdit';
import CarrierVehicleEdit from './CarrierVehicleEdit';
import CarrierContractEdit from './CarrierContractEdit';
import CarrierHome from './CarrierHome/CarrierHome';
import LoadingSection from 'components/LoadingSection';

import { CarriersContextProvider } from './context/';
import useCarriersLite from 'utils/hooks/useCarriersLite';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import { CarrierFormFields, EditCarrierPage, NewCarrierPage } from '@ontruck/fe-core';
import { injectIntl } from 'react-intl';
import CarriersListPage from 'modules/carriersv2/carriersListPage';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import CarrierUsersList from 'modules/carriersv2/components/carrierUsers/carrierUserList';
import NewCarrierUserPage from 'modules/carriersv2/newCarrierUserPage';
import EditCarrierUserPage from 'modules/carriersv2/editCarrierUserPage';

const actionCreators = {
  openFinishedWithFilter,
};

const enhance = compose(connect((state) => ({}), actionCreators));

class Carrier extends Component {
  getRouterActions = ({ match }) => {
    const { query, openFinishedWithFilter } = this.props;

    const id = match.params.id;

    return {
      onCloseModal: () =>
        push({ pathname: `${config.BASE_ROUTE}carrier/${id}`, query, ...preserveScroll }),
      onEditCarrier: () => push({ pathname: `${config.BASE_ROUTE}carrier/${id}/edit`, query }),
      onNewDriver: () => push({ pathname: `${config.BASE_ROUTE}carrier/${id}/driver/new`, query }),
      onNewContract: () =>
        push({
          pathname: `${config.BASE_ROUTE}carrier/${id}/contract/new`,
          query,
          ...preserveScroll,
        }),
      onNewVehicle: () =>
        push({ pathname: `${config.BASE_ROUTE}carrier/${id}/vehicle/new`, query }),
      onEditDriver: (driverId) =>
        push({ pathname: `${config.BASE_ROUTE}carrier/${id}/driver/${driverId}`, query }),
      onEditVehicle: (vehicleId) => {
        push({ pathname: `${config.BASE_ROUTE}carrier/${id}/vehicle/${vehicleId}`, query });
      },
      onEditContract: (contractId) =>
        push({
          pathname: `${config.BASE_ROUTE}carrier/${id}/contract/${contractId}`,
          query,
          ...preserveScroll,
        }),
      onFilterCarrier: (carrier) => openFinishedWithFilter({ carrier }),
      onFilterDriver: (driver) => openFinishedWithFilter({ driver }),
    };
  };

  render() {
    const { match, loading, intl } = this.props;
    const translations = intl.messages.components.CarrierHome;
    const { token, carriersCreationEnabled } = this.props;
    const fatherProps = this.props;

    const isXpo = getTenantPreLoginConfig().company_name === 'XPO Express Now';
    const isOntime = getTenantPreLoginConfig().company_name === 'Ontime';

    // config for intraser new carrier page
    let consumerConfig = {
      api_url: `${config.BASE_URL}/`,
      on_success: (createdId) => {
        setTimeout(() => {
          push({ pathname: `${config.BASE_ROUTE}carrier/${createdId}` });
        }, 1000);
      },
      on_discard: () => {
        push({ pathname: `${config.BASE_ROUTE}carrier` });
      },
      token,
      translations,
      hidden_fields: [
        CarrierFormFields.ExternalCarrierId,
        CarrierFormFields.Rating,
        CarrierFormFields.WorkingAreas,
      ],
      with_driver: true,
    };

    // config for xpo new carrier page
    if (isXpo) {
      consumerConfig = {
        api_url: `${config.BASE_URL}/`,
        on_success: () => {
          push({ pathname: `${config.BASE_ROUTE}carrier` });
        },
        on_discard: () => {
          push({ pathname: `${config.BASE_ROUTE}carrier` });
        },
        token,
        translations,
        hidden_fields: [
          CarrierFormFields.Email,
          CarrierFormFields.PhoneSecondary,
          CarrierFormFields.Zipcode,
          CarrierFormFields.City,
          CarrierFormFields.AddressLine,
          CarrierFormFields.ContactName,
          CarrierFormFields.Phone,
        ],
        with_driver: false,
        pageTitle: 'New carrier',
        withBackground: true,
      };
    }

    if (loading) {
      return <LoadingSection />;
    }

    return (
      <Fragment>
        <Route
          exact
          path={match.url}
          render={(props) => {
            if (isXpo || isOntime) {
              return <CarriersListPage />;
            }
            return (
              <CarriersContextProvider>
                <CarrierHome {...this.getRouterActions(props)} {...props} />
              </CarriersContextProvider>
            );
          }}
        />

        <Route
          path={`${match.url}/new/`}
          exact
          render={() => {
            if (!carriersCreationEnabled) return <Redirect to={`${config.BASE_ROUTE}carrier`} />;
            return (
              <NewCarrierPage {...consumerConfig}>
                {isXpo || isOntime ? <CarrierUsersList carrierId={null} /> : null}
              </NewCarrierPage>
            );
          }}
        />
        <Route
          path={`${match.url}/:id/carrier_user/new`}
          exact
          render={(props) => {
            if (!isXpo && !isOntime) return <Redirect to={`${config.BASE_ROUTE}carrier`} />;
            return <NewCarrierUserPage carrierId={props.match.params.id} />;
          }}
        />
        <Route
          path={`${match.url}/:id/carrier_user/:carrier_user_id/edit`}
          exact
          render={(props) => {
            if (!isXpo && !isOntime) return <Redirect to={`${config.BASE_ROUTE}carrier`} />;
            return (
              <EditCarrierUserPage
                carrierId={props.match.params.id}
                carrierUserId={props.match.params.carrier_user_id}
              />
            );
          }}
        />
        <Route
          path={`${match.url}/:id/edit`}
          exact
          render={(props) => {
            const enhancedProps = { ...fatherProps, ...props };
            if (isXpo || isOntime) {
              // config for xpo edit carrier page
              consumerConfig = {
                api_url: `${config.BASE_URL}/`,
                on_success: () => {
                  push({ pathname: `${config.BASE_ROUTE}carrier` });
                },
                on_discard: () => {
                  push({ pathname: `${config.BASE_ROUTE}carrier` });
                },
                token,
                translations,
                hidden_fields: [
                  CarrierFormFields.Email,
                  CarrierFormFields.PhoneSecondary,
                  CarrierFormFields.Zipcode,
                  CarrierFormFields.City,
                  CarrierFormFields.AddressLine,
                  CarrierFormFields.ContactName,
                  CarrierFormFields.Phone,
                ],
                with_driver: false,
                pageTitle: 'Edit carrier',
                carrier_id: props.match.params.id,
                withBackground: true,
              };

              return (
                <EditCarrierPage {...consumerConfig}>
                  {isXpo || isOntime ? (
                    <CarrierUsersList carrierId={props.match.params.id} />
                  ) : null}
                </EditCarrierPage>
              );
            }
            if (!isXpo && !isOntime) {
              return <CarrierEdit {...this.getRouterActions(props)} {...enhancedProps} />;
            }
          }}
        />
        <Route
          path={`${match.url}/:id/driver/:driver_id`}
          render={(props) => {
            const enhancedProps = { ...fatherProps, ...props };
            return <CarrierDriverEdit {...this.getRouterActions(props)} {...enhancedProps} />;
          }}
        />
        <Route
          path={`${match.url}/:id/vehicle/:vehicle_id`}
          render={(props) => {
            const enhancedProps = { ...fatherProps, ...props };
            return <CarrierVehicleEdit {...this.getRouterActions(props)} {...enhancedProps} />;
          }}
        />
        <Route
          path={`${match.url}/:id/contract/:contract_id`}
          render={(props) => <CarrierContractEdit {...this.getRouterActions(props)} {...props} />}
        />
        <Route
          path={`${match.url}/:id`}
          render={(props) => {
            if (isXpo || isOntime) return <></>;
            const enhancedProps = { ...fatherProps, ...props };
            return <CarrierDetails {...this.getRouterActions(props)} {...enhancedProps} />;
          }}
        />
      </Fragment>
    );
  }
}

Carrier.propTypes = {
  match: PropTypes.object,
  query: PropTypes.object,
  openFinishedWithFilter: PropTypes.func,
  loading: PropTypes.bool,
};
const HookHOCWrapper = (props) => {
  //allow use of hooks inside classes
  const carriersLite = useCarriersLite();
  const token = useSelector((state) => state?.user?.access_token);
  const carriersCreationEnabled = useSelector((state) =>
    getSpecificClientConfig(state, constants.CARRIERS_CREATION_ENABLED)
  );

  props = {
    ...props,
    ...carriersLite,
    token,
    carriersCreationEnabled,
  };

  return <Carrier {...props} />;
};

export default injectIntl(enhance(HookHOCWrapper));
